<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>优惠券管理</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          class="search-form"
          size="small"
        >
          <el-form-item label="优惠券名称" prop="name">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入优惠券名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-select
              v-model="searchForm.status"
              placeholder="请选择状态"
              filterable
              clearable
            >
              <el-option
                v-for="item in statuss"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="getList('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div style="display: flex; align-items: center">
          <h3 style="margin-bottom: 0">列表数据</h3>
        </div>
      </div>
      <div id="base-list">
        <lb-table
          v-loading="loading"
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo"
          :page-size="searchForm.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>
  <script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data () {
    return {
      dataList: {
        list: [
          { title: '营销管理', path: '', type: '0' },
          { title: '优惠券管理', path: '', type: '1' }
        ]
      },
      searchForm: {
        id: '',
        name: '',
        userId: '',
        username: '',
        phone: '',
        vipLevel: '',
        categoryIds: [],
        openTimeStart: '',
        openTimeEnd: '',
        status: '',
        pageNo: 1,
        pageSize: 10
      },
      openTime: [],
      statuss: [
        {
          id: '1',
          name: '已启用'
        },
        {
          id: '0',
          name: '已禁用'
        }
      ],
      list: [
        {
          name: '天兰',
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        }
      ],
      columns: [
        { label: '优惠券名称', prop: 'name', minWidth: '120' },
        {
          label: '优惠内容', prop: 'couponText', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <p style="max-height: 60px;line-height:30px; overflow: hidden;text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">{scope.row.couponText ? scope.row.couponText : '--'}</p>
              </div>
            )
          }
        },
        { label: '优惠金额', prop: 'price', minWidth: '120', },
        { label: '已领取', prop: 'hasNum', minWidth: '120' },
        { label: '已使用', prop: 'useNum', minWidth: '120' },
        {
          label: '创建时间', prop: 'createdTime', minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.createdTime ? scope.row.createdTime : '--'}</p>
              </div>
            )
          }
        },

        {
          label: '状态',
          width: '200',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.statusLabel == '已启用') {
              vv = <p style="color:#666666;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background: #12AB62;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px;margin-left:10px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else {
              vv = <p style="color:#666666;font-size:14px;display:flex"><div style="width: 10px;height: 10px;background: #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px;margin-left:10px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            }

            return (
              <div style="margin-left:60px"> {vv}</div>
            )

          }
        },
        {
          label: '操作',
          minWidth: '180',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.add('look', scope.row.id) }}>查看</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.add('use', scope.row.id) }}>使用详情</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.add('receive', scope.row.id) }}>领取详情</span>
                {/* <el-link size='mini' type='primary' onClick={() => { this.add('edit', scope.row.id) }}>查看</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('use', scope.row.id) }}>使用详情</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.add('receive', scope.row.id) }}>领取详情</el-link> */}
              </div>
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      categoryList: [],
      dictionaries: {},
      loading: false
    }
  },
  created () {
    //   this.getCategoryList()
    //   this.getDictionaries('platform_vip_level')
    this.getList()
  },
  mounted () {

  },
  methods: {
    //导出
    deriveDeliver () {
      this.$api.exportPlatformsList(this.searchForm).then(res => {
        if (res.code == 0) {
          this.downloadlink(res.data)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
        }
      })
    },
    downloadlink (url) {
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = url
      document.body.appendChild(iframe)
    },
    onChangeCategory () {

    },
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.searchForm.pageNo = currentChange
      this.getList()
    },
    handleSizeChange (sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.getList()
    },
    getList (type) {
      if (type == 'reset') {
        this.searchForm = {}
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      this.axios.post('/users/couponPageList', this.searchForm).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.status == 1) {
              item.statusLabel = '已启用'
            } else {
              item.statusLabel = '已禁用'
            }
          })
          this.list = res.data.list
          this.page.totalNum = res.data.totalNum
          this.loading = false;
        }
      })
    },
    // 获取字典数据
    getDictionaries (type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries['platform_vip_level'] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList () {
      const params = {}
      this.$api.categoryList(params).then((res) => {
        res.data.list.forEach(item => {
          if (item.children) {
            item.children.forEach(itm => {
              if (itm.children) {
                delete itm.children
              }
            })
          }
        })
        this.categoryList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    add (type, id) {
      if (type == 'look') {
        this.$router.push({
          name: 'couponDetail',
          query: {
            type: type,
            id: id
          }
        })
      } else if (type == 'use') {
        this.$router.push({
          name: 'useDetail',
          query: {
            type: type,
            id: id
          }
        })
      } else if (type == 'receive') {
        this.$router.push({
          name: 'receiveDetail',
          query: {
            type: type,
            id: id
          }
        })
      } else {
        this.$router.push({
          name: 'platListDetail',
          query: {
            type: type,
            id: id
          }
        })
      }

    },
    setting () {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    }
  }
}
  </script>
  <style  lang="scss">
.el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
  <style scoped lang="scss">
::v-deep .el-cascader-panel:first-child .el-checkbox {
  display: none !important;
}
::v-deep .el-cascader-panel li[aria-haspopup] .el-checkbox {
  display: none !important;
}
.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}
.title {
  display: flex;
  justify-content: space-between;
}
#base-list {
  margin-top: 20px;
}
:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  a {
    margin: 0 5px;
  }
}
.search-form {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }
    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;
      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
  
  